export default function unsetNodesAfterDelete({ props, state }) {
  let path = state.get('node.deleteNode').split('.')
  const removePath = path => {
    path.splice(-2, 2)
    return path
  }
  state.unset(state.get('node.deleteNode'))
  path = removePath(path)

  if (path.length > 2) {
    const parentPath = path.join('.')
    const parent = state.get(parentPath)
    if (Object.keys(parent.nodes).length === 0) {
      state.merge(`${parentPath}`, { hasNodes: false, expanded: false })
      state.unset(`${parentPath}.nodes`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/unsetNodesAfterDelete.js